import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

interface Breadcrumb {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: Breadcrumb[];
  className?: string;
  showHome?: boolean;
}

export const Breadcrumbs = ({
  items,
  className = '',
  showHome = true
}: BreadcrumbsProps) => {
  return (
    <nav
      className={`flex items-center space-x-2 text-sm ${className}`}
      aria-label="Breadcrumbs"
    >
      {showHome && (
        <>
          <Link
            to="/"
            className="text-gray-400 hover:text-amber-400 transition-colors"
            aria-label="Home"
          >
            <Home className="w-4 h-4" />
          </Link>
          <ChevronRight className="w-4 h-4 text-gray-600" aria-hidden="true" />
        </>
      )}

      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={item.label}>
            {item.href && !isLast ? (
              <Link
                to={item.href}
                className="text-gray-400 hover:text-amber-400 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-amber-400' : 'text-gray-400'}>
                {item.label}
              </span>
            )}
            
            {!isLast && (
              <ChevronRight
                className="w-4 h-4 text-gray-600"
                aria-hidden="true"
              />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};